<ion-content>
<div class="jf">
  <header class="jf-fej">
    <img src="assets/icon/jogszabalyfigyelo-logo.svg" alt="" class="jf-logo">
    <div>
      <h2>Jogszabályfigyelő</h2>
      <div class="halvany" *ngIf="adat">Frissítve: {{ datumIdo(adat.generalva) }} UTC · {{ tetelek.length }} tétel · fejlesztői nézet, nem publikus</div>
    </div>
    <span class="jf-spacer"></span>
    <button type="button" class="jf-gomb masod" (click)="futasNyitva = !futasNyitva">
      <ion-icon [name]="futas?.fut ? 'pulse' : 'play-circle-outline'"></ion-icon>{{ futas?.fut ? 'Fut: ' + (futas.mod || '') : 'Futtatás' }}</button>
    <button type="button" class="jf-gomb masod" (click)="betolt()" [disabled]="tolt">
      <ion-icon name="refresh"></ion-icon>{{ tolt ? 'Betöltés…' : 'Frissítés' }}</button>
  </header>

  <!-- ── Futtatás és élő követés ── -->
  <section class="jf-futas" *ngIf="futasNyitva">
    <div class="jf-futas-sor">
      <select [(ngModel)]="futMod" [disabled]="futas?.fut || inditas">
        <option *ngFor="let m of modok" [value]="m[0]">{{ m[1] }}</option>
      </select>
      <button type="button" class="jf-gomb" (click)="futtat()" [disabled]="futas?.fut || inditas">
        <ion-icon name="play"></ion-icon>{{ inditas ? 'Indítás…' : 'Indítás' }}</button>
      <span class="jf-futas-all" *ngIf="futas">
        <span class="pont" [class.fut]="futas.fut"></span>
        <ng-container *ngIf="futas.fut">Fut: <b>{{ modNev(futas.mod) }}</b> · indult {{ futas.kezdet?.slice(11, 16) }}</ng-container>
        <ng-container *ngIf="!futas.fut && futas.kezdet">Utolsó kör: {{ modNev(futas.mod) }} · {{ futas.kezdet }}{{ futas.kesz ? ' · kész' : '' }}</ng-container>
      </span>
    </div>
    <div class="jf-hiba" *ngIf="futHiba">{{ futHiba }}</div>
    <div class="jf-futas-naplo" #futNaplo>
      <div *ngFor="let s of futas?.sorok || []" [class]="'sor ' + sorOsztaly(s)">{{ s }}</div>
      <div class="sor halvany" *ngIf="!(futas?.sorok?.length)">Még nincs futás a mai naplóban.</div>
    </div>
    <div class="halvany">Az oktatási, napi és heti kör a Claude-elemzéssel együtt 10–40 percig tart; egyszerre egy kör fut. A lépések (olvasott fájl, keresés, letöltés, írás) futás közben jelennek meg.</div>
  </section>

  <div class="jf-hiba" *ngIf="hiba">{{ hiba }}</div>

  <nav class="jf-fulek" *ngIf="adat">
    <button type="button" [class.akt]="lap === 'attekintes'" (click)="lapValt('attekintes')">Áttekintés</button>
    <button type="button" [class.akt]="lap === 'valtozasok'" (click)="lapValt('valtozasok')">Változások
      <span class="jf-szam" *ngIf="olvasatlanDb">{{ olvasatlanDb }}</span></button>
    <button type="button" [class.akt]="lap === 'oktatas'" (click)="lapValt('oktatas')">Oktatás
      <span class="jf-szam" *ngIf="kovDb('nem') + kovDb('reszben')">{{ kovDb('nem') + kovDb('reszben') }}</span></button>
    <button type="button" [class.akt]="lap === 'jogszabalyok'" (click)="lapValt('jogszabalyok')">Figyelt jogszabályok</button>
    <button type="button" [class.akt]="lap === 'naplo'" (click)="lapValt('naplo')">Jelzésnapló</button>
    <button type="button" [class.akt]="lap === 'rendszer'" (click)="lapValt('rendszer')">Rendszer
      <span class="jf-szam" *ngIf="hibasForras">{{ hibasForras }}</span></button>
  </nav>

  <!-- ── Áttekintés ── -->
  <ng-container *ngIf="adat && lap === 'attekintes'">
    <div class="jf-mutatok">
      <div class="jf-mutato" *ngFor="let m of mutatok"><b [class.piros]="m.piros">{{ m.n }}</b><span>{{ m.sz }}</span></div>
    </div>

    <h3>Közelgő hatálybalépések</h3>
    <div class="jf-idovonal" *ngIf="kozelgo.length; else nincsKozelgo">
      <div class="jf-pont" *ngFor="let t of kozelgo" [class.bizonytalan]="t.hatalyba_biztos === false">
        <b>{{ t.hatalyba }}</b>
        <span class="c sarga" *ngIf="t.hatalyba_biztos === false">várható</span>
        <button type="button" class="jf-link" (click)="ugras(t.id)">{{ t.cim }}</button>
        <span class="c lila" *ngFor="let m of t.modulok" [title]="modulNev(m)">{{ m }}</span>
        <span class="c">{{ allapotNev(t.allapot) }}</span>
      </div>
    </div>
    <ng-template #nincsKozelgo><p class="halvany">Nincs ismert jövőbeli hatálybalépés.</p></ng-template>

    <h3>Kulcsszámok</h3>
    <div class="jf-tabla-keret">
      <table class="jf-tabla">
        <thead><tr><th>Paraméter</th><th>Modul</th><th>A programban</th><th *ngFor="let ev of evek">{{ ev }}</th><th>Megjegyzés</th></tr></thead>
        <tbody>
          <tr *ngFor="let s of kulcsszamok">
            <td><b>{{ s.nev }}</b><div class="halvany" *ngIf="s.jogszabaly">{{ s.jogszabaly }}</div></td>
            <td><span class="c lila" *ngFor="let m of s.modulok">{{ m }}</span></td>
            <td>{{ s.program_erteke ?? '–' }}<div class="halvany" *ngIf="s.hol"><code>{{ s.hol }}</code></div></td>
            <td *ngFor="let ev of evek">
              <ng-container *ngIf="s.ertekek?.[ev] as x; else ures">
                <a *ngIf="x.url; else sima" [href]="x.url" target="_blank" rel="noopener">{{ x.ertek ?? '?' }}</a>
                <ng-template #sima>{{ x.ertek ?? '?' }}</ng-template>
                <div><span class="c" [ngClass]="ertekOsztaly(x.allapot)">{{ allapotNev(x.allapot) }}</span>
                  <span class="c piros" *ngIf="elter(s, ev)">eltér a programtól</span></div>
              </ng-container>
              <ng-template #ures><span class="halvany">–</span></ng-template>
            </td>
            <td class="halvany">{{ s.megjegyzes }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- ── Változások ── -->
  <ng-container *ngIf="adat && lap === 'valtozasok'">
    <div class="jf-szurok">
      <input type="search" [(ngModel)]="sz.q" placeholder="Keresés (cím, jogszabály, paraméter…)">
      <select [(ngModel)]="sz.modul"><option value="">Minden modul</option>
        <option *ngFor="let m of modulok" [value]="m[0]">{{ m[0] }} – {{ m[1].nev }}</option></select>
      <select [(ngModel)]="sz.allapot"><option value="">Minden állapot</option>
        <option *ngFor="let a of allapotok" [value]="a[0]">{{ a[1] }}</option><option value="elvetve">Elvetve</option></select>
      <select [(ngModel)]="sz.font"><option value="">Minden fontosság</option>
        <option value="magas">Magas</option><option value="kozepes">Közepes</option><option value="alacsony">Alacsony</option></select>
      <select [(ngModel)]="sz.sajat"><option value="nyitott">Nyitottak</option><option value="olvasatlan">Olvasatlan / frissült</option>
        <option value="">Mind</option><option value="feladat">Feladat kiadva</option><option value="kesz">Kész</option><option value="nem_erint">Nem érint</option></select>
      <select [(ngModel)]="sz.rend"><option value="teendo">Fontosság, majd hatálybalépés</option>
        <option value="hataly">Hatálybalépés szerint</option><option value="friss">Legutóbb változott</option></select>
    </div>

    <p class="halvany" *ngIf="!lista.length">Nincs a szűrésnek megfelelő tétel.</p>
    <article class="jf-tetel" *ngFor="let t of lista" [id]="'jf-' + t.id" [ngClass]="t.fontossag" [class.lezart]="!nyitott(t)">
      <div class="jf-sor">
        <span class="c" [ngClass]="t.fontossag === 'magas' ? 'piros' : t.fontossag === 'kozepes' ? 'sarga' : ''">{{ t.fontossag === 'magas' ? 'Magas' : t.fontossag === 'kozepes' ? 'Közepes' : 'Alacsony' }}</span>
        <span class="c" [ngClass]="hatalyOsztaly(t)">{{ hatalyCimke(t) }}</span>
        <span class="c lila" *ngFor="let m of t.modulok" [title]="modulNev(m)">{{ m }}</span>
        <span class="c piros" *ngIf="olvasatlan(t)">{{ frissult(t) ? 'frissült' : 'új' }}</span>
      </div>
      <h4>{{ t.cim }}</h4>
      <div class="jf-lepcso" *ngIf="t.allapot !== 'elvetve'; else elvetve">
        <span *ngFor="let l of lepcso(t.allapot)" [ngClass]="l.o">{{ l.n }}</span>
      </div>
      <ng-template #elvetve><div class="jf-lepcso"><span class="itt">Elvetve / visszavonva</span></div></ng-template>
      <div class="jf-szoveg" [innerHTML]="md(t.osszefoglalo)"></div>
      <div class="halvany" *ngIf="t.jogszabalyok?.length">Érintett jogszabály: {{ t.jogszabalyok.join('; ') }}</div>

      <details *ngIf="t.parameterek?.length" open>
        <summary>Paraméterek ({{ t.parameterek.length }})</summary>
        <div class="jf-tabla-keret"><table class="jf-tabla">
          <thead><tr><th>Paraméter</th><th>Most</th><th>Új</th><th>Hol a programban</th></tr></thead>
          <tbody><tr *ngFor="let p of t.parameterek">
            <td>{{ p.nev }}</td><td [class.jf-kesz]="p.kesz">{{ p.kesz ? '✓ ' : '' }}{{ p.regi ?? '–' }}</td><td><b>{{ p.uj ?? '?' }}</b></td>
            <td><code *ngIf="p.hol">{{ p.hol }}</code></td></tr></tbody>
        </table></div>
      </details>
      <details *ngIf="t.fejlesztesi_feladat" [open]="t.fontossag === 'magas'">
        <summary>Fejlesztési feladat</summary>
        <div class="jf-feladat" [innerHTML]="md(t.fejlesztesi_feladat)"></div>
      </details>
      <details *ngIf="t.forrasok?.length">
        <summary>Források ({{ t.forrasok.length }})</summary>
        <ul><li *ngFor="let f of t.forrasok"><a [href]="f.url" target="_blank" rel="noopener">{{ f.cim || f.url }}</a>
          <span class="halvany"> {{ f.datum }}{{ f.tipus === 'masodlagos' ? ' · másodlagos forrás' : '' }}</span></li></ul>
      </details>
      <details *ngIf="t.tortenet?.length">
        <summary>Történet</summary>
        <ul><li *ngFor="let h of t.tortenet.slice().reverse()"><span class="halvany">{{ h.datum }}</span> {{ h.esemeny }}</li></ul>
      </details>

      <div class="jf-sajat">
        <select [ngModel]="jel[t.id]?.allapot || ''" (ngModelChange)="jelol(t, $event)">
          <option *ngFor="let o of sajatOpciok" [value]="o[0]">{{ o[1] }}</option></select>
        <input [ngModel]="jel[t.id]?.megjegyzes || ''" (change)="jelol(t, undefined, $any($event.target).value)" placeholder="Megjegyzés (pl. feladatszám, commit)">
        <button type="button" class="jf-gomb masod" (click)="masol(t)">{{ masolva === t.id ? 'Kimásolva ✓' : 'Feladat másolása' }}</button>
        <span class="halvany">{{ jel[t.id]?.mikor ? 'jelölve: ' + jel[t.id].mikor.slice(0, 10) + ' · ' : '' }}első észlelés: {{ (t.elso_eszleles || '').slice(0, 10) }}</span>
      </div>
    </article>
  </ng-container>

  <!-- ── Oktatás: a tanulmányi rendszer követelményei + oktatási változások ── -->
  <ng-container *ngIf="adat && lap === 'oktatas'">
    <h3>A tanulmányi rendszer követelményei (SULINFORM)</h3>
    <p class="halvany">A jogszabályok szerinti követelmények és a SULINFORM megfelelése – a kóddal szemben ellenőrizve; az elemző hetente újranézi, és minden oktatási jogszabályváltozásnál frissíti.</p>
    <div class="jf-mutatok">
      <div class="jf-mutato"><b>{{ kovetelmenyek.length }}</b><span>követelmény</span></div>
      <div class="jf-mutato"><b>{{ kovDb('megfelel') }}</b><span>megfelel</span></div>
      <div class="jf-mutato"><b [class.piros]="kovDb('reszben') > 0">{{ kovDb('reszben') }}</b><span>részben felel meg</span></div>
      <div class="jf-mutato"><b [class.piros]="kovDb('nem') > 0">{{ kovDb('nem') }}</b><span>nem felel meg</span></div>
      <div class="jf-mutato"><b>{{ kovDb('nem_vizsgalt') }}</b><span>még nem vizsgált</span></div>
    </div>
    <div class="jf-szurok" style="margin-top:12px">
      <input type="search" [(ngModel)]="osz.q" placeholder="Keresés a követelményekben…">
      <select [(ngModel)]="osz.kat"><option value="">Minden kategória</option>
        <option *ngFor="let c of kovKategoriak" [value]="c">{{ c }}</option></select>
      <select [(ngModel)]="osz.mf"><option value="">Minden megfelelés</option>
        <option *ngFor="let m of megfelelesek" [value]="m[0]">{{ m[1][1] }}</option></select>
    </div>
    <p class="halvany" *ngIf="!kovSzurt.length">Nincs a szűrésnek megfelelő követelmény.</p>
    <ng-container *ngFor="let c of kovSzurtKategoriak">
      <h4 class="jf-kat">{{ c }}</h4>
      <div class="jf-tabla-keret"><table class="jf-tabla">
        <thead><tr><th>Követelmény</th><th>Megfelelés</th><th>Hol a programban</th><th>Teendő</th></tr></thead>
        <tbody><tr *ngFor="let k of kovKategoriaban(c)">
          <td><b>{{ k.cim }}</b><div>{{ k.kovetelmeny }}</div>
            <div class="halvany"><a *ngIf="k.url; else jogalapSima" [href]="k.url" target="_blank" rel="noopener">{{ k.jogalap }}</a>
              <ng-template #jogalapSima>{{ k.jogalap }}</ng-template> · {{ kireNev(k.kire) }}</div></td>
          <td class="nw"><span class="c" [ngClass]="mfOsztaly(k.megfeleles)">{{ mfNev(k.megfeleles) }}</span>
            <span class="c piros" *ngIf="k.fontossag === 'magas'">magas</span><div class="halvany">{{ k.ellenorizve }}</div></td>
          <td><code *ngIf="k.hol">{{ k.hol }}</code><div class="halvany" *ngIf="k.megjegyzes">{{ k.megjegyzes }}</div></td>
          <td><div *ngIf="k.teendo" [innerHTML]="md(k.teendo)"></div>
            <button type="button" class="jf-link" *ngFor="let t of k.tetelek || []" (click)="ugras(t)">{{ t }}</button></td>
        </tr></tbody>
      </table></div>
    </ng-container>

    <h3>Oktatási változások</h3>
    <p class="halvany" *ngIf="!oktatasiTetelek.length">Nincs nyitott oktatási tétel.</p>
    <article class="jf-tetel" *ngFor="let t of oktatasiTetelek" [ngClass]="t.fontossag">
      <div class="jf-sor">
        <span class="c" [ngClass]="hatalyOsztaly(t)">{{ hatalyCimke(t) }}</span>
        <span class="c">{{ allapotNev(t.allapot) }}</span>
        <span class="c piros" *ngIf="olvasatlan(t)">{{ frissult(t) ? 'frissült' : 'új' }}</span>
      </div>
      <h4><button type="button" class="jf-link" (click)="ugras(t.id)">{{ t.cim }}</button></h4>
      <div class="jf-szoveg" [innerHTML]="md(t.osszefoglalo)"></div>
    </article>
  </ng-container>

  <!-- ── Figyelt jogszabályok ── -->
  <ng-container *ngIf="adat && lap === 'jogszabalyok'">
    <p class="halvany">A figyelt jogszabályok hatályos és már kihirdetett, de még nem hatályos időállapotai a Nemzeti Jogszabálytárból. Egy új jövőbeli időállapot = kihirdetett módosítás vár hatálybalépésre.</p>
    <div class="jf-tabla-keret"><table class="jf-tabla">
      <thead><tr><th>Jogszabály</th><th>Modulok</th><th>Hatályos időállapot</th><th>Jövőbeli időállapotok</th><th>Ellenőrizve</th></tr></thead>
      <tbody><tr *ngFor="let j of jogszabalyok">
        <td><a [href]="j.url" target="_blank" rel="noopener">{{ j.azonosito }}</a><div class="halvany">{{ j.cim }}</div>
          <span class="c piros" *ngIf="j.hiba">{{ j.hiba }}</span></td>
        <td><span class="c lila" *ngFor="let m of j.modulok">{{ m }}</span></td>
        <td>{{ j.hatalyos_idoallapot || '–' }}</td>
        <td><span *ngFor="let d of j.jovobeni" class="c" [ngClass]="j.uj_jovobeni?.includes(d) ? 'piros' : 'kek'">{{ d >= '2900' ? 'határozatlan' : d }}</span>
          <span class="halvany" *ngIf="!j.jovobeni?.length">nincs</span></td>
        <td class="halvany">{{ datumIdo(j.ellenorizve) }}</td>
      </tr></tbody>
    </table></div>
  </ng-container>

  <!-- ── Jelzésnapló ── -->
  <ng-container *ngIf="adat && lap === 'naplo'">
    <p class="halvany">A gyűjtők nyers jelzései és az elemző döntése (az utolsó 400).</p>
    <div class="jf-tabla-keret"><table class="jf-tabla">
      <thead><tr><th>Dátum</th><th>Forrás</th><th>Jelzés</th><th>Elemzés</th></tr></thead>
      <tbody><tr *ngFor="let j of jelzesek">
        <td class="halvany nw">{{ j.datum }}</td><td><span class="c">{{ j.forras }}</span></td>
        <td><a [href]="j.url" target="_blank" rel="noopener">{{ j.cim }}</a></td>
        <td>
          <ng-container *ngIf="j.dontes; else elemzesreVar">
            <span class="c" [ngClass]="j.dontes.relevans ? 'zold' : ''">{{ j.dontes.relevans ? 'releváns' : 'nem érint' }}</span>
            <button type="button" class="jf-link" *ngIf="j.dontes.tetel_id" (click)="ugras(j.dontes.tetel_id)">{{ j.dontes.tetel_id }}</button>
            <div class="halvany">{{ j.dontes.indok }}</div>
          </ng-container>
          <ng-template #elemzesreVar><span class="c sarga">elemzésre vár</span></ng-template>
        </td>
      </tr></tbody>
    </table></div>
  </ng-container>

  <!-- ── Rendszer ── -->
  <ng-container *ngIf="adat && lap === 'rendszer'">
    <h3>Források</h3>
    <div class="jf-tabla-keret"><table class="jf-tabla">
      <thead><tr><th>Forrás</th><th>Utolsó futás</th><th>Utolsó sikeres</th><th>Új / összes</th><th>Állapot</th></tr></thead>
      <tbody><tr *ngFor="let f of forrasok">
        <td>{{ f.nev || f.id }}</td><td>{{ datumIdo(f.utolso_futas) }}</td><td>{{ datumIdo(f.utolso_siker) }}</td>
        <td>{{ f.uj_db ?? '–' }} / {{ f.osszes_db ?? '–' }}</td>
        <td><span class="c" [ngClass]="f.hiba ? 'piros' : 'zold'">{{ f.hiba || 'rendben' }}</span></td>
      </tr></tbody>
    </table></div>
    <h3>Futások</h3>
    <div class="jf-tabla-keret"><table class="jf-tabla">
      <thead><tr><th>Kezdet</th><th>Lépés</th><th>Időtartam</th><th>Eredmény</th></tr></thead>
      <tbody><tr *ngFor="let x of futasok">
        <td class="nw">{{ datumIdo(x.kezdet) }}</td><td>{{ x.lepes }}</td><td>{{ x.mp != null ? x.mp + ' mp' : '' }}</td>
        <td><span class="c piros" *ngIf="x.hiba">{{ x.hiba }}</span>{{ x.hiba ? '' : (x.eredmeny || 'rendben') }}</td>
      </tr></tbody>
    </table></div>
    <p class="halvany">Adatforrás: {{ adat.forras || '–' }} (a fejlesztői gépen futó jogszabalyfigyelo/ szolgáltatás).</p>
  </ng-container>
</div>
</ion-content>
